import logo from './Img/logo-camacol-atlantico.png';
import evento from './Img/rueda-de-networking.jpeg'

export default {
    "logo": logo,
    "evento": evento
}